
import Vue from 'vue'

import Breadcrumb from '@/components/Breadcrumb' // 面包屑

Vue.component('bread-crumb', Breadcrumb)
